<script lang="ts">
  import { utils } from "$lib/utils";
  import ImageComp from "$components/image.svelte";
  import LinkComp from "$components/link.svelte";
  import Suggestion from "$components/promo/suggestion.svelte";
  import { onMount, onDestroy } from "svelte";

  interface IFeatured {
    title: string;
    datetime: Date;
    venueId: string;
    subcategory: {
      slug: string;
      title: string;
    };
    product: {
      proceedPrice: number;
    };
    venue: {
      title: string;
    };
    slug: string;
    img: { path: string };
  }

  export let featured: IFeatured[] = [];
  let featureLength = featured.length;
  let isActive = true;
  $: index = 0;
  let timeoutId: NodeJS.Timeout;
  const debouceTime = 5000;

  function runInterval() {
    timeoutId = setInterval(async () => goToNextAuto(), debouceTime);
  }

  function goToNextAuto() {
    isActive = false;
    const next = index + 1;
    if (next >= featureLength) {
      index = 0;
    } else {
      index = next;
    }
    isActive = true;
  }

  function goToPrev() {
    const prev = index - 1;
    emptyInterval();
    runInterval();
    if (prev < 0) {
      index = featureLength - 1;
    }
    if (prev >= 0) {
      index = prev;
    }
  }

  function goToNext() {
    isActive = false;
    const next = index + 1;
    emptyInterval();
    runInterval();
    if (next >= featureLength) {
      index = 0;
    } else {
      index = next;
    }
    isActive = true;
  }

  function emptyInterval() {
    clearInterval(timeoutId);
  }

  const item = { title: "Featured", colour: "#C90090" };

  onMount(() => {
    if (featured.length > 1) {
      runInterval();
    }
  });

  onDestroy(() => clearInterval(timeoutId));
</script>

{#if featured.length}
  <div class="slider-component">
    <section class="carousel-container">
      <div class={`picture-container ${isActive ? "active" : "not-active"}`}>
        <ImageComp image={{ path: featured[index]?.img?.path }} />
      </div>
      <div class="fixture">
        <div class="inner-ixture">
          <div class="feature">
            <Suggestion title={item?.title} className="featured" colour={item?.colour} />
          </div>
          <h2 class="pf-600">{featured[index]?.title}</h2>
          <p class="pf-400">
            {featured[index]?.subcategory?.title}
            {utils.nt(`${featured[index]?.product?.proceedPrice || 0}`, "en")}
          </p>
          <LinkComp href={featured[index]?.slug}>
            <button class="book sf-500">Book Now</button>
          </LinkComp>
        </div>
        {#if featured.length > 1}
          <div class="arrow grid">
            <button on:click={goToPrev}><i class="left" /></button>
            <button on:click={goToNext}><i class="right" /></button>
          </div>
        {/if}
      </div>
    </section>
  </div>
{/if}

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;

  .slider-component {
    color: #fff;
    .carousel-container {
      /* position: relative; */
      display: grid;
      grid-template-columns: 35% auto;
      gap: 30px;
      margin-bottom: 0;
    }

    .picture-container {
      margin-top: 5em;
    }

    .fixture {
      margin-top: 5em;
      /* margin: 5em 0 0 13.125em; */
      min-height: 25em;
      display: grid;
      grid-template-columns: 1fr;
      position: relative;

      .feature {
        width: 6em;
        font-size: 1.125em;
        margin-bottom: 2.4375em;
        font-weight: 600;
        font-family: var(--secondary-font);
      }

      h2,
      p {
        color: #fff;
        font-family: var(--secondary-font);
        width: 100%;
        line-height: 50px; /* 277.778% */
        text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
      }

      h2 {
        font-size: 2.5em;
        font-style: normal;
        margin: 0;
      }
      p {
        font-size: 1.125em;
        font-style: normal;
        margin-bottom: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .arrow {
        position: absolute;
        top: 14em;
        right: 0;
        grid-template-columns: 50% 50%;

        .left {
          background: url("./left-arrow.svg");
        }
        .right {
          background: url("./right-arrow.svg");
        }
        button {
          background-color: unset;
          border: unset;
          line-height: 30px;
        }

        .left,
        .right {
          background-repeat: no-repeat;
          background-size: cover;

          display: inline-block;
          width: 1.5em;
          height: 4em;
        }
      }
    }

    .book {
      padding: 0;
      width: 170px;
      height: 45px;
      border: 1px solid #fff;
      font-size: 1.125em;
      line-height: 1.875em;
      background-color: unset;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    }
  }
</style>
